import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface PlannerIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function PlannerIcon({ isSelected = false, isHover = false, style = {}, ...props }: PlannerIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9528 0.904236H6.88499V2.69974C6.88499 3.25202 6.43728 3.69974 5.88499 3.69974C5.33271 3.69974 4.88499 3.25202 4.88499 2.69974V0.904236H4.60263C2.20806 0.904236 0.26923 2.85042 0.26923 5.24826V14.7518C0.26923 17.1496 2.20806 19.0958 4.60263 19.0958H15.3974C17.7919 19.0958 19.7308 17.1496 19.7308 14.7518V5.24826C19.7308 2.85042 17.7919 0.904236 15.3974 0.904236H14.9528V2.69974C14.9528 3.25202 14.5051 3.69974 13.9528 3.69974C13.4005 3.69974 12.9528 3.25202 12.9528 2.69974V0.904236ZM4.91821 9.0837C5.67869 9.0837 6.29517 8.4655 6.29517 7.70292C6.29517 6.94034 5.67869 6.32214 4.91821 6.32214C4.15773 6.32214 3.54124 6.94034 3.54124 7.70292C3.54124 8.4655 4.15773 9.0837 4.91821 9.0837ZM16.4587 7.70292C16.4587 8.4655 15.8423 9.0837 15.0818 9.0837C14.3213 9.0837 13.7048 8.4655 13.7048 7.70292C13.7048 6.94034 14.3213 6.32214 15.0818 6.32214C15.8423 6.32214 16.4587 6.94034 16.4587 7.70292ZM15.0818 14.9137C15.8423 14.9137 16.4587 14.2955 16.4587 13.5329C16.4587 12.7703 15.8423 12.1521 15.0818 12.1521C14.3213 12.1521 13.7048 12.7703 13.7048 13.5329C13.7048 14.2955 14.3213 14.9137 15.0818 14.9137ZM11.377 13.584C11.377 14.3466 10.7605 14.9648 10 14.9648C9.23952 14.9648 8.62303 14.3466 8.62303 13.584C8.62303 12.8214 9.23952 12.2032 10 12.2032C10.7605 12.2032 11.377 12.8214 11.377 13.584Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
      </g>
    </SvgIcon>
  );
}
